import { getFiliation, setFiliation, getPublicFiliation, lockFiliation } from "@/taskpane/services/filiation";
import { MutationOptions, useMutation, useQuery, UseQueryOptions } from "@tanstack/react-query";

export const useGetFiliationQuery = (
  folderId: string,
  flowId: string,
  opt?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getFiliation>>>>
) =>
  useQuery({
    ...opt,
    queryFn: () => getFiliation({ folderId, flowId }),
    queryKey: ["getFiliation", folderId, flowId],
  });

export const useSetFiliationMutation = (
  opt?: MutationOptions<Awaited<ReturnType<typeof setFiliation>>, Error, Parameters<typeof setFiliation>[0]>
) => {
  return useMutation({
    ...opt,
    mutationFn: setFiliation,
  });
};

export const useLockFiliationMutation = (
  opt?: MutationOptions<Awaited<ReturnType<typeof lockFiliation>>, Error, Parameters<typeof lockFiliation>[0]>
) => {
  return useMutation({
    ...opt,
    mutationFn: lockFiliation,
  });
};

export const useGetPublicFiliationQuery = (
  clientId: string,
  dossierId: string,
  sousDossierId: string,
  flowId: string,
  opt?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getPublicFiliation>>>>
) =>
  useQuery({
    ...opt,
    queryFn: () => getPublicFiliation({ clientId, dossierId, sousDossierId, flowId }) as Promise<any | undefined>,
    queryKey: ["getPublicFiliation", clientId, dossierId, sousDossierId, flowId],
  });
